import React from 'react';
import styles from './OptOutFooter.module.css';

export const OptOutFooter = () => (
  <div className={styles.container}>
    <p className={styles.title}>
      The California Consumer Privacy Act (CCPA), gives residents of the state
      of California the right to prevent businesses from selling their personal
      information.
    </p>
    <p className={styles.body}>
      California residents may exercise their right to opt-out by sending an
      email to support[at]customers.ai withdrawing their consent to resell their
      personal information to third parties. They may authorize other persons to
      act on their behalf solely for the purposes of exercising their right to
      opt-out. The content of the email should include the email address of the
      person exercising the right to opt-out. Any personal information provided
      in the email in connection with the submission of the opt-out request will
      be used solely for the purposes of complying with the request.
    </p>
  </div>
);
